const starNames = [
'Acamar',
'Achernar',
'Achird',
'Acrab',
'Acrux',
'Acubens',
'Adhafera',
'Adhara',
'Adhil',
'Ain',
'Ainalrami',
'Aladfar',
'Albaldah',
'Albali',
'Albireo',
'Alchiba',
'Alkor',
'Alcyone',
'Aldebaran',
'Alderamin',
'Aldhanab',
'Aldhibah',
'Aldulfin',
'Alfirk',
'Algedi',
'Algenib',
'Algieba',
'Algol',
'Algorab',
'Alhena',
'Alioth',
'Aljanah',
'Alkaid',
'Alkalurops',
'Alkaphrah',
'Alkarab',
'Alkes',
'Almaaz',
'Almach',
'Alnair',
'Alnasl',
'Alnilam',
'Alnitak',
'Alniyat',
'Alphard',
'Alphecca',
'Alpheratz',
'Alpherg',
'Alrakis',
'Alrescha',
'Alruba',
'Alsafi',
'Alsciaukat',
'Alsephina',
'Alshain',
'Alshat',
'Altair',
'Altais',
'Alterf',
'Aludra',
'Alula Australis',
'Alula Borealis',
'Alzirr',
'Ancha',
'Angetenar',
'Ankaa',
'Anser',
'Antares',
'Arcturus',
'Arkab Posterior',
'Arkab Prior',
'Arneb',
'Ascella',
'Asellus Australis',
'Asellus Borealis',
'Ashlesha',
'Aspidiske',
'Asterope',
'Athebyne',
'Atik',
'Atlas',
'Atria',
'Avior',
'Azelfafage',
'Azha',
'Azmidi',
'Barnards star',
'Baten Kaitos',
'Beemim',
'Beid',
'Bellatrix',
'Betelgeuse',
'Bharani',
'Biham',
'Botein',
'Brachium',
'Bunda',
'Canopus',
'Capella',
'Caph',
'Castor',
'Castula',
'Cebalrai',
'Celaeno',
'Cervantes',
'Chalawan',
'Chamukuy',
'Chara',
'Chertan',
'Copernicus',
'Cor Caroli',
'Cujam',
'Cursa',
'Dabih',
'Dalim',
'Deneb',
'Deneb Algedi',
'Denebola',
'Diadem',
'Diphda',
'Dschubba',
'Dubhe',
'Dziban',
'Edasich',
'Electra',
'Elgafar',
'Elkurud',
'Elnath',
'Eltanin',
'Enif',
'Errai',
'Fafnir',
'Fang',
'Fawaris',
'Felis',
'Fomalhaut',
'Fulu',
'Fumalsamakah',
'Fum as-Samaka',
'Furud',
'Fuyue',
'Gacrux',
'Giausar',
'Lambda Draconis',
'Gienah',
'Ginan',
'Gomeisa',
'Grumium',
'Gudja',
'Guniibuu',
'Hadar',
'Haedus',
'Hamal',
'Hassaleh',
'Hatysa',
'Helvetios',
'Heze',
'Homam',
'Iklil',
'Intercrus',
'Izar',
'Jabbah',
'Jishui',
'Kaffaljidhma',
'Kang',
'Kaus Australis',
'Kaus Borealis',
'Kaus Media',
'Keid',
'Khambalia',
'Kitalpha',
'Kochab',
'Kornephoros',
'Kraz',
'Kurhah',
'La Superba',
'Larawag',
'Lesath',
'Libertas',
'Lich',
'Lilii Borea',
'Maasym',
'Mahasim',
'Maia',
'Marfik',
'Markab',
'Markeb',
'Marsic',
'Matar',
'Mebsuta',
'Megrez',
'Meissa',
'Mekbuda',
'Meleph',
'Menkalinan',
'Menkar',
'Menkent',
'Menkib',
'Merak',
'Merga',
'Meridiana',
'Merope',
'Mesarthim',
'Miaplacidus',
'Mimosa',
'Minchir',
'Minelauva',
'Mintaka',
'Mira',
'Mirach',
'Miram',
'Mirfak',
'Mirzam',
'Misam',
'Mizar',
'Mothallah',
'Muliphein',
'Muphrid',
'Muscida',
'Musica',
'Nahn',
'Naos',
'Nashira',
'Nekkar',
'Nembus',
'Nihal',
'Nusakan',
'Ogma',
'Okab',
'Paikauhale',
'Peacock',
'Phecda',
'Pherkad Pherkard',
'Piautos',
'Pipirima',
'Pleione',
'Polaris',
'Polaris Australis',
'Polis',
'Pollux',
'Porrima',
'Praecipua Leonis Minoris',
'Prima Hyadum',
'Prokyon',
'Propus',
'Proxima Centauri',
'Ran',
'Rasalas',
'Rasalgethi',
'Rasalhague',
'Rastaban',
'Regulus',
'Revati',
'Rigel',
'Rigil Kentaurus',
'Rotanev',
'Ruchbah',
'Rukbat',
'Sabik',
'Saclateni',
'Sadachbia',
'Sadalbari',
'Sadalmelik',
'Sadalsuud',
'Sadr',
'Saiph',
'Salm',
'Sargas',
'Sarin',
'Sceptrum',
'Scheat',
'Schedar',
'Secunda Hyadum',
'Segin',
'Seginus',
'Sham',
'Shaula',
'Sheliak',
'Sheratan',
'Sirius',
'Situla',
'Skat',
'Spica',
'Sualocin',
'Subra',
'Sulafat',
'Syrma',
'Tabit',
'Taiyangshou',
'Taiyi',
'Talitha',
'Tania Australis',
'Tania Borealis',
'Tarazed',
'Tarf',
'Taygeta',
'Tegmine',
'Tejat',
'Terebellum',
'Theemin',
'Thuban',
'Tiaki',
'Tianguan',
'Tianyi',
'Titawin',
'Toliman',
'Tonatiuh',
'Torcular',
'Tureis',
'Ukdah',
'Unukalhai',
'Unurgunite',
'Vega',
'Veritate',
'Vindemiatrix',
'Wasat',
'Wazn',
'Wezen',
'Wurren',
'Xamidimura',
'Xuange',
'Yed Posterior',
'Yed Prior',
'Yildun',
'Zaniah',
'Zaurak',
'Zavijava',
'Zhang',
'Zibal',
'Zosma',
'Zubenelgenubi',
'Zubenelhakrabi'
]

export default starNames